import Tabs from "components/lib/Shared/Tabs";
import { useState, useEffect } from "react";
import Summary from "./Summary";
import SubscriptionPlans from "./SubscriptionPlans";
import Subscribers from "./Subscribers";
import Revenues from "./Revenues";
import EwalletHoldings from "./EwalletHoldings";
import {
  ClipboardCheckIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  CurrencyEuroIcon,
  UsersIcon,
} from "@heroicons/react/outline";
import { getProductsAsync } from "state/slices/product";
import { useDispatch, useSelector } from "react-redux";
import SidebarItem from "./SidebarItems";
import Cookies from "js-cookie";
import { Constants } from "config/constants";

const genTabs = [
  { id: "summary", label: "Summary", Icon: ClipboardCheckIcon },

  {
    id: "ewallet-holdings",
    label: "Ewallet Holdings",
    Icon: CurrencyDollarIcon,
    disabled: true,
  },
];
const defaultManagementTabs = [
  { id: "subscriptions", label: "Subscription Plans", Icon: CreditCardIcon },

  {
    id: "client-fees",
    label: "Client Fees",
    Icon: UsersIcon,
  },
  {
    id: "subscribers",
    label: "Subscribers",
    Icon: UsersIcon,
  },
  {
    id: "expenses",
    label: "Expenses",
    Icon: CurrencyDollarIcon,
    disabled: true,
  },

  {
    id: "revenues",
    label: "Revenues",
    Icon: CurrencyEuroIcon,
    disabled: true,
  },
  {
    id: "services-marketplace",
    label: "Services Marketplace",
    Icon: CurrencyDollarIcon,
    disabled: true,
  },
];
const billingTabs = [
  {
    id: "account-settings",
    label: "Account Settings",
    Icon: CurrencyDollarIcon,
    disabled: true,
  },
  {
    id: "notifications",
    label: "Notifications ",
    Icon: CurrencyDollarIcon,
    disabled: true,
  },
  {
    id: "transactions",
    label: "Transactions",
    Icon: CurrencyDollarIcon,
    disabled: true,
  },
  {
    id: "audit-trails",
    label: "Audit Trails",
    Icon: CurrencyDollarIcon,
    disabled: true,
  },
];

const Subscriptions = () => {
  const cookieRole = Cookies.get("role");
  const [generalTabs, setGeneralTabs] = useState([...genTabs]);
  const [managementTabs, setManagementTabs] = useState(defaultManagementTabs);
  const [selectedTab, setSelectedTab] = useState(generalTabs[0]);
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.userSlice);

  useEffect(() => {
    dispatch(getProductsAsync());
  }, []);

  const handleTabClick = (item) => {
    if (item?.disabled) return;
    setSelectedTab(item);
  };

  useEffect(() => {
    if (cookieRole === Constants.COOKIE_ROLES.ORG_ADMIN) {
      setGeneralTabs([
        { id: "summary", label: "Summary", Icon: ClipboardCheckIcon },
        {
          id: "ewallet-holdings",
          label: "Ewallet Holdings",
          Icon: CurrencyDollarIcon,
          disabled: true,
        },
      ]);
      setManagementTabs(defaultManagementTabs);
    } else if (cookieRole === Constants.COOKIE_ROLES.SUPER_ADMIN) {
      if (selectedTab?.id === "subscriptions") {
        setSelectedTab(generalTabs[0]);
      }
      setGeneralTabs(genTabs);
      setManagementTabs([
        {
          id: "client-fees",
          label: "Subscription Plans",
          Icon: UsersIcon,
        },
        ...defaultManagementTabs.slice(2),
      ]);
    }
  }, [cookieRole]);

  const renderSidebar = () => {
    return (
      <div className="col-span-4 md:col-span-1 pt-8">
        <div>
          <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
            <span className="pl-2">Overview</span>
          </h4>
          <ul className="ml-10">
            {generalTabs.map((item) => (
              <SidebarItem
                key={item.label}
                item={item}
                selectedTab={selectedTab}
                handleTabClick={handleTabClick}
              />
            ))}
          </ul>
        </div>
        <div className="border-t pt-2">
          <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
            <span className="pl-2">Tenant Management</span>
          </h4>
          <ul className="ml-10">
            {managementTabs.map((item) => (
              <SidebarItem
                key={item.label}
                item={item}
                selectedTab={selectedTab}
                handleTabClick={handleTabClick}
              />
            ))}
          </ul>
        </div>
        <div className="border-t pt-2">
          <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
            <span className="pl-2">Platform Settings</span>
          </h4>
          <ul className="ml-10">
            {billingTabs.map((item) => (
              <SidebarItem
                key={item.label}
                item={item}
                selectedTab={selectedTab}
                handleTabClick={handleTabClick}
              />
            ))}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-5 border-gray">
      <div className="col-span-5 md:col-span-1 pt-2">{renderSidebar()}</div>

      <div className="col-span-5 md:border-l md:col-span-4 md:pl-11 pt-14 border-gray">
        {selectedTab.id === "summary" && <Summary />}
        {selectedTab.id === "subscriptions" && (
          <SubscriptionPlans manageSubscriptions={false} />
        )}
        {selectedTab.id === "client-fees" && (
          <SubscriptionPlans manageSubscriptions={true} />
        )}
        {selectedTab.id === "subscribers" && <Subscribers />}
        {selectedTab.id === "revenues" && <Revenues />}
        {selectedTab.id === "ewallet-holdings" && <EwalletHoldings />}
      </div>
    </div>
  );
};

export default Subscriptions;
